
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[...param]",
      function () {
        return require("private-next-pages/category/[...param].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[...param]"])
      });
    }
  